import { Mail, Phone, Instagram, MapPin } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { Btn, Label } from "@/components/site/Ui";
import ContactForm from "@/components/site/forms/ContactForm";
import { contact, brand } from "@/content/site";
import { useSeo } from "@/lib/seo";

function Row({ icon: Icon, label, children, testid }) {
  return (
    <li className="flex gap-5 border-b border-ink/20 py-5" data-testid={testid}>
      <Icon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" />
      <div><p className="label">{label}</p><div className="mt-1 text-[17px] font-medium">{children}</div></div>
    </li>
  );
}

export default function Contact() {
  useSeo({
    title: "Contact — web designer à Toulouse",
    description: "Contactez Sanaa, web designer à Toulouse : contact@sanaadesignstudio.fr — 06 65 31 11 73. Sites, réservation en ligne et visibilité Google.",
    path: "/contact",
  });
  return (
    <section className="wrap pt-32 pb-20 md:pt-44" data-testid="contact-page">
      <Label className="mb-8">Contact</Label>
      <MaskLines as="h1" onLoad className="display h-xl max-w-5xl" lines={["Parlons de votre commerce."]} />
      <div className="mt-14 grid gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <ul className="border-t border-ink/20">
            <Row icon={Phone} label="Téléphone" testid="contact-phone"><a className="link-u" href={`tel:${contact.phoneIntl}`} data-track="phone_click">{contact.phone}</a></Row>
            <Row icon={Mail} label="E-mail" testid="contact-email"><a className="link-u break-all" href={`mailto:${contact.email}`} data-track="email_click">{contact.email}</a></Row>
            <Row icon={Instagram} label="Instagram" testid="contact-instagram"><a className="link-u" href={contact.instagram.url} target="_blank" rel="noopener noreferrer" data-track="instagram_click">{contact.instagram.handle}</a></Row>
            <Row icon={MapPin} label="Zone d'intervention" testid="contact-city">Partout en {brand.area}</Row>
          </ul>
          <div className="mt-8 flex flex-col gap-3">
            <Btn href={`tel:${contact.phoneIntl}`} track="phone_click" testid="contact-call-btn">Appeler maintenant</Btn>
            <Btn to="/diagnostic" variant="outline" track="cta_diagnostic" testid="contact-diagnostic-cta">Demander un diagnostic</Btn>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-7 lg:col-start-6">
          <h2 className="display mb-8 text-[1.9rem] md:text-[2.3rem]">Écrivez-moi</h2>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
